


















































































































































































































































































































































































































import Component, {mixins} from "vue-class-component";
import Vue from "vue";
import MobileMixin from "@/mixins/mobileMixin";
import {Groupe, Profil, Societe} from "@/shared/Groupe";
import {User, UserComplement} from "@/shared/User";
import ErrorMixin from "@/mixins/errorMixins";
import VueJsonToCsv from "vue-json-to-csv";
import ConfigMixin from "@/mixins/ConfigMixin";
import {Watch} from "vue-property-decorator";
import _ from "lodash";

@Component({
  components: {VueJsonToCsv},
})
export default class Utilisateurs extends mixins(
    MobileMixin,
    ErrorMixin,
    ConfigMixin
) {
  public search: string = "";
  public selectedUser: User = new User();
  public confirmDelete: boolean = false;
  public addGr: boolean = false;
  public editGr: boolean = false;
  public showAddSite: boolean = false;
  public showAddGr: boolean = false;
  public showExSite: boolean = false;
  public showExGr: boolean = false;
  public passError: boolean = false;
  public editPass: boolean = false;
  public show: boolean = false;
  public needReload: boolean = false;
  public show2: boolean = false;
  public refreshKey: number = 0;
  public honeypot: string = "";
  public startTime: number = 0;
  public isFormEnabled: boolean = false;
  public restaurantIds_to_enseigne: any = {};
  public restaurantIds_to_codeAlpha: any = {};

  public created() {
    this.resIdToCodeAlpha(this.restaurantIds_to_codeAlpha);
    this.resIdToEnseignes(this.restaurantIds_to_enseigne);
  }

  public mounted() {
    // Initialisation de l'empreinte du navigateur
    this.startTime = Date.now();
    this.isFormEnabled = this.generateBrowserFingerprint() !== null;

    // Si l'empreinte est invalide, remplir le honeypot
    if (!this.isFormEnabled) {
      this.honeypot = "INPUT-" + Math.random().toString(36).slice(2);
    }

    this.$store.dispatch("config/getUtilisateurs");
  }

  @Watch("selectedUser.newPassword")
  public onNewPasswordValueChanged(val: number) {
    this.comparePassword();
  }

  @Watch("selectedUser.rePasswordKey")
  public onRePasswordKeyValueChanged(val: number) {
    this.comparePassword();
  }

  get isFormValid() {
    // Vérifie si les champs obligatoires sont remplis

    // Vérifie si le login est rempli
    const isLoginValid = !!this.selectedUser.login;
    // Vérifie si l'email est valide
    let isEmailValid = (this.selectedUser.email !== "" && /.+@.+\..+/.test(this.selectedUser.email)) || this.selectedUser.email === "";
    // Vérifie si le mot de passe est valide
    const isPasswordValid = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{10,}$/.test(this.selectedUser.newPassword || "");
    // Vérifie si les mots de passe correspondent
    const isPasswordMatch = this.selectedUser.newPassword === this.selectedUser.rePasswordKey;
    const isProfileValid = this.selectedUser.profile.id !== ""; // Vérifie si le profil est sélectionné
    const isCountryValid = !!this.selectedUser.country; // Vérifie si le pays est sélectionné
    const isLanguageValid = !!this.selectedUser.language; // Vérifie si la langue est sélectionnée

    if (this.editPass && !this.editGr) {
      isEmailValid = true;
    }

    const validationTotal = [
      isLoginValid,
      isEmailValid,
      isPasswordValid,
      isPasswordMatch,
      isProfileValid,
      !this.passError,
    ];

    const validation = [
      isLoginValid,
      isEmailValid,
      isPasswordValid,
      isPasswordMatch,
      isProfileValid,
      isCountryValid,
      isLanguageValid,
      !this.passError,
    ];

    if (this.client === "TOTAL") {
      return validationTotal.every((v) => v);
    } else {
      return validation.every((v) => v);
    }
  }

  public generateBrowserFingerprint(): string | null {
    try {
      const userAgent = navigator.userAgent;
      const screenRes = `${window.screen.width}x${window.screen.height}`;
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      // Crée une empreinte unique en combinant différentes propriétés
      return `${userAgent}-${screenRes}-${timezone}`;
    } catch (e) {
      return null; // Si quelque chose échoue, renvoie null
    }
  }

  public submitForm(save: boolean) {
    const timeTaken = Date.now() - this.startTime;
    if (this.honeypot !== "" || timeTaken < 8 * 1000) {
      // Si le honeypot est rempli ou le temps écoulé est inférieur à 8 secondes, on ne fait rien
      return;
    }
    if (!save) {
      this.saveUser();
    }
  }

  /**
   * methode de filtre des users existants correspondant au texte entrée dans le champs de recherche
   */
  public getFilteredUsers(): User[] {
    let usrs = this.users.filter(
        (user: User) =>
            !user.caisse &&
            user.login &&
            user.login.toLowerCase().includes(this.search.toLowerCase())
    );
    if (usrs.length === 0) {
      // this.addGr = true;
    }
    usrs = _.sortBy(usrs, [(o: any) => o.login]);
    return usrs;
  }

  /**
   * methode permettant de verifier si il faut ou non afficher la partie selection de site/ groupe
   */
  public isSiteLimited() {
    return this.selectedUser.profile.droits.includes("LIMITATION_SITE");
  }

  /**
   * methode pour le code exploitant total
   */
  public getCodeExploitant() {
    let code = "";
    if (this.selectedUser.complements && this.selectedUser.complements.length > 0) {
      const complement = this.selectedUser.complements
          .filter(
              (cmpl: UserComplement) => cmpl.cle === "code_exploitant"
          );
      code = complement[0].valeur;
    }

    this.selectedUser.codeExploitant = code;
    return code;
  }

  /**
   * Création d'un nouveau user au click sur entrée
   * (activé quand aucun user de correspondant à la recherche n'est trouvé)
   */
  public onKeydown(evt: any, add?: boolean) {
    if (evt.keyCode === 13) {
      if (this.addGr || add) {
        this.selectedUser = new User();
        this.selectedUser.$edit = true;

        if (this.search !== "") {
          this.selectedUser.login = this.search;
        }

        this.editGr = true;
        this.editPass = true;
      } else {
        this.selectedUser = this.getFilteredUsers()[0];
      }
    }
  }

  public extract() {
    let usersJson: any[];

    usersJson = this.users.map((user: any) => {
      return this.transformUser(user);
    });

    return usersJson;
  }

  /**
   * methode permettant de comparer les deux mots de passe saisis
   */
  public comparePassword() {
    this.passError = this.selectedUser.newPassword !== this.selectedUser.rePasswordKey && this.selectedUser.newPassword !== "";
  }

  /**
   * methode de selection du groupe selectionné
   */
  public selectUser(user: User) {
    if (user.id !== this.selectedUser.id) {
      this.selectedUser = {
        ...user,
        raisonsSociales: [...user.raisonsSociales],
        restaurantIds: [...user.restaurantIds],
        init: user.init,
      };

      this.selectedUser.$edit = true;
      this.passError = false;

      if (this.needReload) {
        this.$store.dispatch("config/getUtilisateurs");
        this.needReload = false;
      }
    }
  }

  /**
   * méthode de récupération de l'icone a afficher dans le champ de recherche
   * une loupe si on trouve des users correspondant
   * un plus si on ne trouve pas pour proposer l'ajout
   */
  public getIcon() {
    if (this.addGr) {
      return "icon-plus";
    } else {
      return "icon-look";
    }
  }

  /**
   * Affichage d'une message de confirmation de la suppression d'un user
   */
  public confirmDeleteUser() {
    this.confirmDelete = true;
  }

  /**
   * methode permettant d'enregistrerv/ créer le user selectionné
   *
   */
  public saveUser() {
    const user = this.selectedUser;

    if (!this.isFormValid || this.passError) {
      return;
    } else {
      this.editGr = false;
      this.selectedUser.$edit = false;
      this.editPass = false;

      if (user.id && user.id !== "") {
        this.updateselectedUser();
      } else {
        this.addUser(user);
      }
    }
  }

  public UpdateUser() {
    const user = this.selectedUser;

    if (user.id && user.id !== "") {
      this.updateselectedUser();

      // Synchroniser les sites et groupes
      this.synchronizeSites();

      Vue.set(this.selectedUser, "$edit", false);

      this.needReload = true;
      this.refreshKey++;
      this.$forceUpdate();
    } else {
      this.addUser(user);
    }
  }

  public async reset() {
    await this.$store.dispatch("config/getUtilisateurs");
    this.editPass = false;
    this.editGr = false;
    this.selectedUser.$edit = false;

    const foundUser = this.users.find(
        (user) => user.id === this.selectedUser.id
    );
    console.log("utilisateur de la base ", foundUser);
    if (foundUser) {
      this.selectedUser = foundUser;
    }
    console.log("user refresh :", this.selectedUser);
  }

  /**
   * méthode de suppression d"un user
   */
  public removeUser(userToRem: User) {
    this.$store.dispatch("config/removeUser", userToRem)
        .then(
            (response: any) => {
              if (response.status === 200) {
                this.selectedUser = new User();
                this.selectedUser.$edit = false;
                this.confirmDelete = false;
                this.search = "";
                this.setSuccess(
                    this.$t("login").toString() + " " + this.$t("deleted").toString()
                );
              }
            },
            (error: any) => {
              const err = error.toString().substring(7);
              console.log(JSON.parse(err));
              this.setErrorFromTxt(JSON.parse(err));
            }
        );
  }

  /**
   * Méthode pour synchroniser les sites et groupes
   */
  public synchronizeSites() {
    // Extraire les sites de societesPlus qui contient les associations correctes
    const sites = this.selectedUser.societesPlus.map((societe) => ({
      raisonSociale: societe.raisonSociale,
      restaurantId: societe.restaurantId
    }));

    // Vider les tableaux actuels
    this.selectedUser.raisonsSociales = [];
    this.selectedUser.restaurantIds = [];

    // Remplir les tableaux avec les associations correctes
    sites.forEach((site) => {
      this.selectedUser.raisonsSociales.push(site.raisonSociale);
      this.selectedUser.restaurantIds.push(site.restaurantId);
    });

    // Forcer la réactivité
    Vue.set(this.selectedUser, "raisonsSociales", [...this.selectedUser.raisonsSociales]);
    Vue.set(this.selectedUser, "restaurantIds", [...this.selectedUser.restaurantIds]);

    this.refreshKey++;
    this.$forceUpdate();
  }

  private transformUser(user: User) {
    const obj: { [k: string]: any } = {
      login: user.login,
      email: user.email,
      profil: user.profile.titre,
      droits: user.profile.droits.filter((dr: string) =>
          this.matchingDroits(dr)
      ),
      sites: user.raisonsSociales,
      groupes: this.getGroupesOfUser(user.societesPlus),
    };

    if (this.client === "BUFFALO") {
      obj.role = user.role;
    }

    if (this.client === "TOTAL" && user.complements) {
      obj.codeImplant = user.complements.length > 0 ? user.complements[0].valeur : "";
    }

    return obj;
  }

  private getGroupesOfUser(grs: any[]) {
    let groupes = "";

    grs.map((g: any) => {
      if (g.societe0 === null || g.societe0 === undefined) {
        groupes += g.raisonSociale + ", ";
      }
    });

    groupes = groupes.slice(0, -2);
    return groupes;
  }

  private matchingDroits(droit: string) {
    const droits = [
      "LOGIN",
      "CONFIGURATION",
      "ACCES_BASE",
      "LIMITATION_SITE",
      "RAPPORTS_ANOMALIES",
      "AUDIT",
      "FEC_CONFIGURATION",
      "RECURRENCE_CONFIGURATION",
    ];

    return droits.indexOf(droit) !== -1;
  }

  /**
   * methode d"ajout d"un nouveau groupe à la bdd
   */
  private addUser(userToAdd: User) {
    this.search = "";
    this.$store.dispatch("config/addUser", userToAdd)
        .then(
            () => {
              this.setSuccess(
                  this.selectedUser.login + " " + this.$t("added").toString()
              );
            },
            (error: any) => {
              const err = error.toString().substring(7);
              console.log(JSON.parse(err));
              this.setErrorFromTxt(JSON.parse(err));
            }
        );
  }

  /**
   * methode de mise à jour du user dans la bdd et dans le state de l'application
   */
  private updateselectedUser() {
    this.editGr = false;
    this.selectedUser.$edit = false;
    this.editPass = false;

    this.$store.dispatch("config/updateOneUser", this.selectedUser)
        .then(
            () => {
              this.setSuccess(
                  this.selectedUser.login + " " + this.$t("updated").toString()
              );
            },
            (error: any) => {
              const err = error.toString().substring(7);
              console.log(JSON.parse(err));
              this.setErrorFromTxt(JSON.parse(err));
            }
        );
  }

  // Les getters liés au store
  get users(): User[] {
    return this.$store.getters["config/utilisateurs"];
  }

  get getRaisonsSociales(): any[] {
    // Vérifier que les tableaux existent
    if (!this.selectedUser.raisonsSociales || !this.selectedUser.restaurantIds) {
      return [];
    }

    // On va utiliser societesPlus qui contient les associations correctes
    if (this.selectedUser.societesPlus && this.selectedUser.societesPlus.length > 0) {
      return this.selectedUser.societesPlus.map((societe, index) => ({
        raisonSociale: societe.raisonSociale,
        restaurantId: societe.restaurantId,
        index
      }));
    }

    // Fallback sur la méthode originale si societesPlus n'est pas disponible
    const result = [];
    const longueurMax = Math.max(
        this.selectedUser.raisonsSociales.length,
        this.selectedUser.restaurantIds.length
    );

    for (let i = 0; i < longueurMax; i++) {
      result.push({
        raisonSociale: i < this.selectedUser.raisonsSociales.length
            ? this.selectedUser.raisonsSociales[i]
            : this.selectedUser.raisonsSociales[0] || "",
        restaurantId: i < this.selectedUser.restaurantIds.length
            ? this.selectedUser.restaurantIds[i]
            : null,
        index: i
      });
    }

    return result;
  }

  get profils(): Profil[] {
    return this.$store.getters["config/profils"];
  }

  get groupes(): Groupe[] {
    return this.$store.getters["config/groupes"];
  }

  get societes(): Societe[] {
    return this.$store.getters["config/societes"];
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }
}
